module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question border4"
  }, [_c('div', [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.item.createTime)))]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("问题编号：" + _vm._s(_vm.item.orderIdStr))])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(JSON.parse(_vm.item.content)[0].text))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.item.doctorId) ? [_c('img', {
    staticClass: "head",
    attrs: {
      "src": _vm.item.cyDoctor.image,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.item.cyDoctor.name))]), _vm._v(" "), _c('span', {
    staticClass: "job border3"
  }, [_vm._v(_vm._s(_vm.item.cyDoctor.clinic))])] : _vm._e(), _vm._v(" "), (_vm.isDelete) ? _c('span', {
    staticClass: "delete icon-delete",
    attrs: {
      "data-track": "yy_djk_kwys_sc"
    },
    on: {
      "click": function($event) {
        _vm.deleteQuestion(_vm.item.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "status",
    class: _vm.typesClass,
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm.statusText))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60892bc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question.vue
// module id = 603
// module chunks = 1